import React from 'react';
import { useTranslatedContent } from '../../../i18n/hooks/useTranslatedContent';
import MigrationHeroContent from './MigrationHeroContent';
import MigrationHeroImage from './MigrationHeroImage';

const MigrationHero = () => {
  const { t } = useTranslatedContent('migration');

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
      <MigrationHeroContent 
        title={t('hero.title')}
        description={t('hero.description')}
        buttonText={t('hero.buttonText')}
      />
      <MigrationHeroImage />
    </div>
  );
};

export default MigrationHero;